import { z } from 'zod';

const guestSchema = z.object({
  title: z.string().trim().min(1, 'required'),
  firstName: z.string().trim().min(1, 'required'),
  lastName: z.string().trim().min(1, 'required'),
  gender: z.string().trim().min(1, 'required'),
  id: z.string().optional(),
  externalSpaId: z.string().optional(),
});

export const spaEntityFormSchema = z.object({
  date: z.string().min(1, 'required'),
  arrivalTime: z.object({
    startTime: z.string(),
    endTime: z.string(),
    startDateTime: z.string(),
    endDateTime: z.string(),
  }),
  guests: z.array(guestSchema).min(1, 'required'),
  extras: z.record(z.string(), z.any()).optional(),
  notes: z.string().optional(),
});

export type SpaEntityFormValues = z.infer<typeof spaEntityFormSchema>;
